"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _validation = require("../validation");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var validation = function validation(InputComponent) {
  var Validator = function (_React$Component) {
    _inherits(Validator, _React$Component);

    function Validator(props) {
      _classCallCheck(this, Validator);

      var _this = _possibleConstructorReturn(this, (Validator.__proto__ || Object.getPrototypeOf(Validator)).call(this, props));

      _this.state = _this.isValid(props.value);
      _this.validate = _this.validate.bind(_this);
      _this.handleChange = _this.handleChange.bind(_this);
      return _this;
    }

    _createClass(Validator, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.validate(this.props.value);
      }
    }, {
      key: "isValid",
      value: function isValid(value) {
        var _this2 = this;

        var valid = true;
        var error = '';
        this.props.validations.forEach(function (validation) {
          error = validation(value, _this2.props);

          if (error) {
            valid = false;
          }
        });
        return {
          valid: valid,
          error: error
        };
      }
    }, {
      key: "validate",
      value: function validate(value, callback) {
        var _isValid = this.isValid(value),
            valid = _isValid.valid,
            error = _isValid.error;

        if (this.state.valid !== valid || this.state.error !== error) {
          this.setState({
            error: error,
            valid: valid
          }, callback);
        }
      }
    }, {
      key: "handleChange",
      value: function handleChange(event) {
        var target = event.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        this.validate(value, this.props.onChange(event));
      }
    }, {
      key: "renderPlaceholder",
      value: function renderPlaceholder() {
        var placeholder = this.props.placeholder;

        if (this.props.validations.indexOf(_validation.required) !== -1) {
          placeholder += " *";
        }

        return placeholder;
      }
    }, {
      key: "render",
      value: function render() {
        return _react2.default.createElement("div", {
          className: this.state.valid ? 'input' : 'input error'
        }, _react2.default.createElement(InputComponent, _extends({
          data: this.props.data
        }, this.props, {
          onChange: this.handleChange,
          placeholder: this.renderPlaceholder()
        })));
      }
    }]);

    return Validator;
  }(_react2.default.Component);

  Validator.propTypes = {
    value: _propTypes2.default.string.isRequired,
    validations: _propTypes2.default.array.isRequired,
    onChange: _propTypes2.default.func.isRequired
  };
  return Validator;
};

exports.default = validation;